import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/ThemeProvider";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import MarketingLayout from "@/components/MarketingLayout";
import DashboardLayout from "@/components/DashboardLayout";
import ScrollToTop from "@/components/ScrollToTop";
import ProtectedRoute from "@/routes/ProtectedRoute";

import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import RefundPolicy from "@/pages/RefundPolicy";
import ShippingPolicy from "@/pages/ShippingPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

import Dashboard from "@/pages/Dashboard";
import UploadTender from "@/pages/UploadTender";
import AnalysisResult from "@/pages/AnalysisResult";
import AnalysisHistory from "@/pages/AnalysisHistory";
import Reports from "@/pages/Reports";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";

function App() {
    return (
        <ThemeProvider>
            <BrowserRouter>
                <ScrollToTop />
                <AuthProvider>
                    <Routes>
                        <Route element={<MarketingLayout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/pricing" element={<Pricing />} />
                            <Route path="/faq" element={<FAQ />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route path="/terms" element={<Terms />} />
                            <Route path="/refund-policy" element={<RefundPolicy />} />
                            <Route path="/shipping-policy" element={<ShippingPolicy />} />
                            <Route path="/cookie-policy" element={<CookiePolicy />} />
                        </Route>

                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />

                        {/* Protected dashboard routes */}
                        <Route element={<ProtectedRoute />}>
                            <Route element={<DashboardLayout />}>
                                <Route path="/dashboard" element={<Dashboard />} />
                                <Route
                                    path="/dashboard/upload"
                                    element={<UploadTender />}
                                />
                                <Route
                                    path="/dashboard/analysis/:id"
                                    element={<AnalysisResult />}
                                />
                                <Route
                                    path="/dashboard/history"
                                    element={<AnalysisHistory />}
                                />
                                <Route
                                    path="/dashboard/reports"
                                    element={<Reports />}
                                />
                                <Route
                                    path="/dashboard/billing"
                                    element={<Billing />}
                                />
                                <Route
                                    path="/dashboard/settings"
                                    element={<Settings />}
                                />
                            </Route>
                        </Route>
                    </Routes>
                    <Toaster richColors position="top-right" />
                </AuthProvider>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
